// src/pages/Terms.jsx
export default function Terms() {
    return (
        <div className="min-h-screen bg-gray-50 py-10 px-4">
            <div className="max-w-4xl mx-auto bg-white p-8 rounded-xl shadow">
                <h1 className="text-3xl font-bold mb-4 text-gray-800">
                    Terms of Service
                </h1>

                <p className="text-sm text-gray-500 mb-6">
                    Effective Date: January 2026
                </p>

                <p className="mb-4 text-gray-700">
                    By accessing or using MyBioTick, you agree to the following Terms of Service.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">1. Service Description</h2>

                <p className="text-gray-700">
                    MyBioTick provides tools for doctors to manage patient appointments
                    and schedule consultations synced with Google Calendar.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">2. Eligibility</h2>

                <p className="text-gray-700">
                    Only authorized medical professionals may use this platform.
                    Users must provide accurate and up-to-date information.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">3. Google Services</h2>

                <p className="text-gray-700">
                    By signing in with Google, you grant permission to manage
                    consultation-related calendar events. Access can be revoked
                    at any time from your Google account.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">4. User Responsibilities</h2>

                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                    <li>Use the platform only for legitimate healthcare purposes</li>
                    <li>Protect your account credentials</li>
                    <li>Ensure appointment details are accurate</li>
                </ul>

                <h2 className="text-xl font-semibold mt-6 mb-2">5. Prohibited Use</h2>

                <p className="text-gray-700">
                    You may not misuse patient data, attempt unauthorized access,
                    or use the service for unlawful purposes.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">6. Availability</h2>

                <p className="text-gray-700">
                    We strive for reliability but do not guarantee uninterrupted service.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">7. Termination</h2>

                <p className="text-gray-700">
                    We may suspend or terminate accounts for policy violations
                    or misuse of data.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">8. Contact</h2>

                <p className="text-gray-700">
                    Email: <strong>naveen011214@gmail.com</strong>
                </p>
            </div>
        </div>
    );
}
